import React, { lazy, memo } from 'react';
const SplitSections = () => {
  return <section className="py-20 bg-white" data-id="element-723">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-724">
        <div className="text-center mb-16" data-id="element-725">
          <h2 className="text-3xl font-bold text-navy-950 sm:text-4xl" data-id="element-726">
            Office Beverage Solutions
          </h2>
          <p className="mt-4 text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-727">
            Tailored beverage experiences for modern workspaces that prioritize
            taste, sustainability, and affordability
          </p>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-20" data-id="element-728">
          <div data-id="element-729">
            <h3 className="text-2xl font-bold text-navy-950 mb-6" data-id="element-730">
              Boost Employee Satisfaction
            </h3>
            <ul className="space-y-4" data-id="element-731">
              <li className="flex" data-id="element-732">
                <div className="flex-shrink-0" data-id="element-733">
                  <div className="flex items-center justify-center h-8 w-8 rounded-full bg-blue-100 text-blue-500" data-id="element-734">
                    <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-735">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-736" />
                    </svg>
                  </div>
                </div>
                <div className="ml-4" data-id="element-737">
                  <h4 className="text-lg font-medium text-navy-950" data-id="element-738">
                    Premium Beverage Perk
                  </h4>
                  <p className="mt-2 text-gray-600" data-id="element-739">
                    Offer premium beverages as a meaningful perk that improves
                    workplace satisfaction and productivity.
                  </p>
                </div>
              </li>
              <li className="flex" data-id="element-740">
                <div className="flex-shrink-0" data-id="element-741">
                  <div className="flex items-center justify-center h-8 w-8 rounded-full bg-blue-100 text-blue-500" data-id="element-742">
                    <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-743">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-744" />
                    </svg>
                  </div>
                </div>
                <div className="ml-4" data-id="element-745">
                  <h4 className="text-lg font-medium text-navy-950" data-id="element-746">
                    Customizable Options
                  </h4>
                  <p className="mt-2 text-gray-600" data-id="element-747">
                    Provide a variety of beverage choices that cater to
                    different preferences and dietary needs.
                  </p>
                </div>
              </li>
              <li className="flex" data-id="element-748">
                <div className="flex-shrink-0" data-id="element-749">
                  <div className="flex items-center justify-center h-8 w-8 rounded-full bg-blue-100 text-blue-500" data-id="element-750">
                    <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-751">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-752" />
                    </svg>
                  </div>
                </div>
                <div className="ml-4" data-id="element-753">
                  <h4 className="text-lg font-medium text-navy-950" data-id="element-754">
                    Health-Conscious Choices
                  </h4>
                  <p className="mt-2 text-gray-600" data-id="element-755">
                    Support employee wellness with clean-label ingredients and
                    healthier beverage alternatives.
                  </p>
                </div>
              </li>
            </ul>
          </div>
          <div data-id="element-756">
            <div className="relative rounded-2xl overflow-hidden shadow-xl h-80 lg:h-96" data-id="element-757">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/uS7VQZ2Wn65rXUcg6aqNd8/officeSmartSoda.webp" alt="Office team enjoying SmartSoda beverages in break room" className="w-full h-full object-cover object-center" width="600" height="400" loading="lazy" decoding="async" data-id="element-758" />
            </div>
          </div>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-759">
          <div className="order-2 lg:order-1" data-id="element-760">
            <div className="relative rounded-2xl overflow-hidden shadow-xl h-80 lg:h-96" data-id="element-761">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/igGM2hqvV5GZUDYycvv6vV/OfficeSmartSoda_2.webp" alt="Office team enjoying SmartSoda beverages" className="w-full h-full object-cover object-top" width="600" height="400" loading="lazy" decoding="async" data-id="element-762" />
            </div>
          </div>
          <div className="order-1 lg:order-2" data-id="element-763">
            <h3 className="text-2xl font-bold text-navy-950 mb-6" data-id="element-764">
              Impress Clients & Visitors
            </h3>
            <ul className="space-y-4" data-id="element-765">
              <li className="flex" data-id="element-766">
                <div className="flex-shrink-0" data-id="element-767">
                  <div className="flex items-center justify-center h-8 w-8 rounded-full bg-blue-100 text-blue-500" data-id="element-768">
                    <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-769">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-770" />
                    </svg>
                  </div>
                </div>
                <div className="ml-4" data-id="element-771">
                  <h4 className="text-lg font-medium text-navy-950" data-id="element-772">
                    Elevated Meeting Experience
                  </h4>
                  <p className="mt-2 text-gray-600" data-id="element-773">
                    Create memorable impressions with premium beverage options
                    during client meetings and presentations.
                  </p>
                </div>
              </li>
              <li className="flex" data-id="element-774">
                <div className="flex-shrink-0" data-id="element-775">
                  <div className="flex items-center justify-center h-8 w-8 rounded-full bg-blue-100 text-blue-500" data-id="element-776">
                    <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-777">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-778" />
                    </svg>
                  </div>
                </div>
                <div className="ml-4" data-id="element-779">
                  <h4 className="text-lg font-medium text-navy-950" data-id="element-780">
                    Brand Reflection
                  </h4>
                  <p className="mt-2 text-gray-600" data-id="element-781">
                    Showcase your company's commitment to quality and
                    sustainability through your beverage offerings.
                  </p>
                </div>
              </li>
              <li className="flex" data-id="element-782">
                <div className="flex-shrink-0" data-id="element-783">
                  <div className="flex items-center justify-center h-8 w-8 rounded-full bg-blue-100 text-blue-500" data-id="element-784">
                    <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-785">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-786" />
                    </svg>
                  </div>
                </div>
                <div className="ml-4" data-id="element-787">
                  <h4 className="text-lg font-medium text-navy-950" data-id="element-788">
                    Conversation Starter
                  </h4>
                  <p className="mt-2 text-gray-600" data-id="element-789">
                    The SmartSoda system becomes a natural talking point that
                    helps break the ice in professional settings.
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
};
export default SplitSections;